<template>
  <div :class="jel_getClassObject(content)">
    <b-card :header="content.entete" header-tag="header" :footer="content.pied" footer-tag="footer">
      <b-card-text>
        <EditableArea
          v-if="content.carte"
          :content="content.carte"
          :parentTemplateId="metadata['mgnl:template']"
        >
        </EditableArea>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import { EditableArea } from '@/vue-editor';

export default {
  name: 'CarteObsolete',
  components: { EditableArea },
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
};
</script>
